export default __webpack_public_path__ + "static/media/gold.0695b74e.png";